const loadedScripts = new Set();
const INDEX_SCRIPT_SRC = "/scripts/index.js?v=2026-03-14-game-route-sound-fix";

// Mobile detection utility
export function isMobileDevice() {
  if (typeof window === "undefined") return false;
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    ) ||
    "ontouchstart" in window ||
    window.innerWidth <= 768
  );
}

// Check if user prefers reduced motion
export function prefersReducedMotion() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function loadScript(
  src,
  { async = false, defer = false, type = "text/javascript" } = {},
) {
  return new Promise((resolve, reject) => {
    if (
      loadedScripts.has(src) ||
      document.querySelector(`script[src="${src}"]`)
    ) {
      loadedScripts.add(src);
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = async;
    script.defer = defer;
    script.type = type;
    script.dataset.script = src;
    script.onload = () => {
      loadedScripts.add(src);
      resolve();
    };
    script.onerror = (error) => reject(error);

    document.body.appendChild(script);
  });
}

export async function loadAmbientScripts() {
  const mobile = isMobileDevice();
  await Promise.all([
    mobile ? Promise.resolve() : loadScript("/scripts/cursor-trail.js"),
    mobile ? Promise.resolve() : loadScript("/scripts/rain.js"),
  ]);
  if (!mobile) {
    window.__dingInitCursorTrail?.();
  }
}

export async function loadCoreScripts({ includeAmbient = true } = {}) {
  // svgxuse and gsap core are independent — load in parallel
  await Promise.all([
    loadScript("/scripts/svgxuse.min.js"),
    loadScript("https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js"),
  ]);

  // Plugins require gsap core but are independent of each other — load in parallel
  await Promise.all([
    loadScript(
      "https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/CustomEase.min.js",
    ),
    loadScript(
      "https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js",
    ),
  ]);

  if (typeof window !== "undefined" && window.gsap) {
    if (window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
    }
    if (window.CustomEase) {
      window.gsap.registerPlugin(window.CustomEase);
    }
    window.gsapReady = true;
  }

  await Promise.all([
    loadScript(INDEX_SCRIPT_SRC),
    loadScript("/scripts/ripple.js"),
  ]);

  if (includeAmbient) {
    await loadAmbientScripts();
  }
}

export async function loadToolsScript() {
  await loadScript("/scripts/tools.js");
}
